export const Logo = (props: { width?: string; height?: string; animate?: boolean; alt?: string }) => {
  return (
    <>
      <img
        src="/logo.png"
        width={props.width ? props.width : "auto"}
        height={props.height ? props.height : "auto"}
        alt={props.alt || "Logo"}
        style={{
          animation: props.animate ? "logo-rotating 10s linear infinite alternate" : undefined,
        }}
      />
      <style>
        {`
          @keyframes logo-rotating {
            from {
              transform: rotate(20deg);
            }
            to {
        
              transform: rotate(-90deg);
            }
            }
        `}
      </style>
    </>
  );
};
